<template>
  <div>
    <!-- Page Header -->
    <CCard class="mb-4">
      <CCardBody class="p-4">
        <h1 class="h4 mb-1 font-weight-bold">Quick actions</h1>
        <p class="text-muted mb-0">Start a new sales document or jump to your lists</p>
      </CCardBody>
    </CCard>

    <CRow>
      <CCol sm="6" lg="4" v-for="group in groups" :key="group.title" class="mb-4">
        <CCard class="h-100">
          <CCardBody class="p-4">
            <h2 class="h6 font-weight-bold mb-3">{{ group.title }}</h2>
            <div class="d-flex flex-column">
              <router-link
                v-for="link in group.links"
                :key="link.to"
                :to="link.to"
                class="btn btn-light text-left mb-2"
              >
                <CIcon :name="link.icon" class="mr-2" />
                {{ link.label }}
              </router-link>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
export default {
  name: "IncomeMain",
  data() {
    return {
      groups: [
        {
          title: "Quotations",
          links: [
            { label: "Create quotation", to: "/tenants/Quotation", icon: "cil-plus" },
            { label: "All quotations", to: "/tenants/quotationList", icon: "cil-list" },
          ],
        },
        {
          title: "Invoices",
          links: [
            { label: "Create invoice", to: "/tenants/Invoice", icon: "cil-plus" },
            { label: "All invoices", to: "/tenants/InvoiceList", icon: "cil-list" },
          ],
        },
        {
          title: "Income receipts",
          links: [
            { label: "Create income receipt", to: "/tenants/incomeReceipt", icon: "cil-plus" },
            { label: "All income receipts", to: "/tenants/incomeReceiptList", icon: "cil-list" },
          ],
        },
      ],
    };
  },
};
</script>
